<div
  class="flex flex-row align-items-center"
  [style]="{
    'margin-right':
      mobile.isMobileAgent() && mobile.isMobileDevice() ? '30px' : '30px'
  }"
>
  <div
    *ngIf="!hideCreditReserve"
    [style]="{
      'padding-bottom':
        mobile.isMobileAgent() && mobile.isMobileDevice() ? '10px' : '0px'
    }"
    style="display: flex"
  >
    <!--
    <div
      [routerLink]="'/app/credit-reserve'"
      class="border-round h-4rem"
      [ngClass]="
        mobile.isMobileAgent() && mobile.isMobileDevice()
          ? 'shadow-mobile'
          : 'shadow-5'
      "
      style="
        cursor: pointer;
        background-color: '#FFD400';
        color: black;
        padding: 0px 0px;
      "
    >
      <div class="flex align-items-center h-full">
        <div class="flex align-items-center justify-content-around px-3">
          <div style="margin-right: 0px !important">
            <img [src]="'../assets/images/money.png'" style="width: 60%" />
          </div>
          <div class="flex flex-column">
            <div class="p-inputgroup">
              <span
                *ngIf="!isAgent()"
                [ngClass]="
                  mobile.isMobileAgent() && mobile.isMobileDevice()
                    ? 'text-xl'
                    : ''
                "
                style="font-weight: bold"
                ><small>{{ "main.my_credits" | translate }}</small></span
              >
              <span
                *ngIf="isAgent()"
                [ngClass]="
                  mobile.isMobileAgent() && mobile.isMobileDevice()
                    ? 'text-xl'
                    : ''
                "
                style="font-weight: bold"
                ><small>{{ "main.general_balance" | translate }}</small></span
              >
            </div>
            <div class="p-inputgroup">
              <span
                [ngClass]="
                  mobile.isMobileAgent() && mobile.isMobileDevice()
                    ? 'text-xl'
                    : ''
                "
                ><strong>{{
                  creditReserve
                    | currencyFormat
                      : {
                          currencyCode: currencyCode,
                          currencySymbol: currencySymbol,
                          credit: true,
                          currencyRegional: currencyRegional
                        }
                }}</strong>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  -->
    <div
      [routerLink]="'/app/credit-reserve'"
      class="border-round h-4rem"
      [ngClass]="
        mobile.isMobileAgent() && mobile.isMobileDevice()
          ? 'shadow-mobile'
          : 'shadow-5'
      "
      style="
        cursor: pointer;
        background-color: '#0ED18A';
        color: black;
        padding: 0px 0px;
        margin: 0 10px;
      "
      pTooltip="Balance de Créditos disponibles para Abonar a los Players"
      tooltipPosition="bottom"
    >
      <div class="flex align-items-center h-full">
        <div class="flex align-items-center justify-content-around px-3">
          <div style="margin-right: 10px !important">
            <img [src]="'../assets/images/gift.png'" style="max-width: 38px" />
          </div>
          <div class="flex flex-column">
            <div class="p-inputgroup">
              <span
                *ngIf="!isAgent()"
                [ngClass]="
                  mobile.isMobileAgent() && mobile.isMobileDevice()
                    ? 'text-xl'
                    : ''
                "
                style="font-weight: bold"
                ><small>{{ "main.bonus" | translate }}</small></span
              >
              <span
                *ngIf="isAgent()"
                [ngClass]="
                  mobile.isMobileAgent() && mobile.isMobileDevice()
                    ? 'text-xl'
                    : ''
                "
                style="font-weight: bold"
                ><small>{{ "main.bonus" | translate }}</small></span
              >
            </div>
            <div class="p-inputgroup">
              <span
                [ngClass]="
                  mobile.isMobileAgent() && mobile.isMobileDevice()
                    ? 'text-xl'
                    : ''
                "
                ><strong>{{
                  bonusBalance
                    | currencyFormat
                      : {
                          currencyCode: currencyCode,
                          currencySymbol: currencySymbol,
                          credit: true,
                          currencyRegional: currencyRegional
                        }
                }}</strong>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div
        [routerLink]="'/app/credit-reserve'"
        class="border-round h-4rem"
        [ngClass]="
          mobile.isMobileAgent() && mobile.isMobileDevice()
            ? 'shadow-mobile'
            : 'shadow-5'
        "
        style="
          cursor: pointer;
          background-color: '#FFD400';
          color: black;
          padding: 0px 0px;
        "
        pTooltip="Balance de Créditos disponibles para Vender a los Players"
        tooltipPosition="bottom"
      >
        <div class="flex align-items-center h-full">
          <div class="flex align-items-center justify-content-around px-3">
            <div style="margin-right: 10px !important">
              <img
                [src]="'../assets/images/dollar.png'"
                style="max-width: 38px"
              />
            </div>
            <div class="flex flex-column">
              <div class="p-inputgroup">
                <span
                  *ngIf="!isAgent()"
                  [ngClass]="
                    mobile.isMobileAgent() && mobile.isMobileDevice()
                      ? 'text-xl'
                      : ''
                  "
                  style="font-weight: bold"
                  ><small>{{ "main.credits" | translate }}</small></span
                >
                <span
                  *ngIf="isAgent()"
                  [ngClass]="
                    mobile.isMobileAgent() && mobile.isMobileDevice()
                      ? 'text-xl'
                      : ''
                  "
                  style="font-weight: bold"
                  ><small>{{ "main.credits" | translate }}</small></span
                >
              </div>
              <div class="p-inputgroup">
                <span
                  [ngClass]="
                    mobile.isMobileAgent() && mobile.isMobileDevice()
                      ? 'text-xl'
                      : ''
                  "
                  ><strong>{{
                    creditBalance
                      | currencyFormat
                        : {
                            currencyCode: currencyCode,
                            currencySymbol: currencySymbol,
                            credit: true,
                            currencyRegional: currencyRegional
                          }
                  }}</strong>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-1" style="background: transparent">
      <p-menu
        [styleClass]="
          mobile.isMobileAgent() && mobile.isMobileDevice()
            ? 'text-xl w-13rem p-1'
            : 'w-13rem'
        "
        #menu
        [popup]="true"
        [model]="items"
      ></p-menu>
      <a
        [style]="{
          width: '100%',
          'padding-left': '2px',
          background: 'transparent',
          border: 'none',
          'box-shadow': '0px 0px 0px rgb(15 139 253 / 30%)',
          'padding-bottom':
            mobile.isMobileAgent() && mobile.isMobileDevice() ? '15px' : '5px',
          'margin-left':
            mobile.isMobileAgent() && mobile.isMobileDevice() ? '10px' : '5px'
        }"
        pButton
        icon="pi pi-angle-down"
        (click)="menu.toggle($event)"
      >
        <div
          style="border-radius: 100%"
          [class]="
            mobile.isMobileAgent() && mobile.isMobileDevice()
              ? 'shadow-mobile'
              : ''
          "
        >
          <p-avatar
            pBadge
            [size]="
              mobile.isMobileAgent() && mobile.isMobileDevice()
                ? 'xlarge'
                : 'large'
            "
            shape="circle"
            image="{{ profilePicture }}"
          >
          </p-avatar>
        </div>
      </a>
    </div>
  </div>
  <p-sidebar
    [(visible)]="displaySidebar"
    [blockScroll]="true"
    [fullScreen]="true"
    [transitionOptions]="'50ms cubic-bezier(0, 0, 0.2, 1)'"
    [showCloseIcon]="false"
    (onHide)="onCloseConfig()"
  >
    <div class="flex w-full justify-content-between align-items-center">
      <div
        class="flex ml-3 text-4xl align-items-center font-bold"
        style="font-size: 1.875rem"
      >
        <i class="{{ iconSidebar }} text-4xl pr-2"></i>
        {{ titleSidebar }}
      </div>
      <div
        class="flex flex-row closeButton mr-3 cursor-pointer text-xl"
        (click)="closeConfig()"
      >
        <span class="mr-1">Cerrar</span>
        <div class="ml-1" style="margin-top: 2px">
          <i class="pi pi-times text-xl"></i>
        </div>
      </div>
    </div>
    <p-divider></p-divider>
    <app-config-layout *ngIf="renderComponent"></app-config-layout>
  </p-sidebar>
  <p-dialog
    header="Header"
    [(visible)]="alertIncompleteData"
    [closable]="false"
    [modal]="true"
    [style]="{ width: '500px' }"
    [draggable]="false"
  >
    <p-header>
      <div
        style="
          justify-content: left;
          flex-direction: row;
          display: flex;
          align-items: left;
        "
      >
        <i
          class="pi pi-info-circle"
          style="font-size: 2rem; padding-top: 5px"
        ></i>
        <label class="header_title">Completar configuración</label>
      </div>
    </p-header>
    <div style="justify-content: left; display: flex; flex-wrap: wrap">
      <span>Es necesario completar la configuración para poder continuar.</span>
    </div>
    <p-footer>
      <p-button
        icon="pi pi-check"
        (click)="goToConfig(isIncomplete)"
        label="Aceptar"
        styleClass="p-button-text"
      ></p-button>
    </p-footer>
  </p-dialog>
</div>
